import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const pageWidth = props => props.theme.global.size.pageWidth;

export const MainSectionContainer = styled(Box)`
  width: ${({isWmoEnabled, returnsCenter}) => isWmoEnabled && returnsCenter ? pageWidth : '1248px'};
  margin: 0 auto;
  padding: ${({isWmoEnabled, returnsCenter}) => isWmoEnabled && returnsCenter ? '0 16px 16px' : '16px'};
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    padding: 8px;
  }
  flex-direction: ${({ returnsCenter }) => (returnsCenter ? 'column' : 'row')};
`

export const MainSectionBox = styled(Box)`
  width: ${({ returnsCenter }) => (returnsCenter ? '100%' : '80%')};
  ${({ theme, returnsCenter }) => !returnsCenter && theme.mediaQuery.down('tablet-landscape')} {
    width: 100%
  }
`

export const MainSectionStaticBarBox = styled(Box)`
  display: flex;
  ${({ theme, returnsCenter }) => !returnsCenter && theme.mediaQuery.down('tablet-landscape')} {
    display: none;
  }
`
